<template>
  <div class="container" id="goods-edit">
    <!-- 面包屑导航 -->
    <div class="breadcrumb">
      <el-breadcrumb separator="">
        <el-breadcrumb-item>
          <div class="div1">矩阵管理</div>
        </el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/goodsList' }">
          <div class="div2">保证金查看</div>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <!-- 面包屑导航 -->
    <!-- 查询 -->
    <div class="content page-title">
      <h2>平台保证金</h2>
      <bond
        :hadRechargeAmount="hadRechargeAmount"
        :awaitEarnestMoney="awaitEarnestMoney"
        :activeEarnestMoney="activeEarnestMoney"
      ></bond>
    </div>
    <div class="content">
      <h3>数据筛选</h3>
      <div>
        <el-form
          :inline="true"
          :model="searchForm"
          ref="searchForm"
          size="small"
        >
          <el-form-item label="时间" prop="brandId">
            <el-date-picker
              v-model="updatedTime"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :default-time="['00:00:00', '23:59:59']"
              value-format="yyyy-MM-dd HH:mm:ss"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="商品名称" prop="goodsName">
            <el-input
              v-model="searchForm.goodsName"
              placeholder="请输入商品名称"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="类型" prop="type">
            <el-select
              v-model="searchForm.type"
              placeholder="请选择类型"
              filterable
              clearable
            >
              <el-option
                v-for="item in types"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态" prop="status">
            <el-select
              v-model="searchForm.status"
              placeholder="请选择状态"
              filterable
              clearable
            >
              <el-option
                v-for="item in dictionaries.platform_earnest_status"
                :key="item.dictId"
                :label="item.dictName"
                :value="item.dictId"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="fetchData('search')"
              >查询</el-button
            >
            <el-button type="primary" plain @click="fetchData('reset')"
              >重置</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="content">
      <div class="title">
        <h3>列表数据</h3>
        <div>
          <el-button type="primary" @click="toFreeze">冻结金额</el-button>
          <el-button type="primary" @click="deriveDeliver">导出</el-button>
        </div>
      </div>
      <div id="base-list">
        <lb-table
          v-horizontal-scroll="'always'"
          :column="columns"
          :data="page.list"
          pagination
          :total="page.totalNum"
          layout="total, sizes, prev, pager, next, jumper"
          :page-sizes="[5, 10, 20, 30, 50]"
          :current-page.sync="page.currentPage"
          :page-size="page.pageSize"
          @selection-change="onMultipleSelection"
          @size-change="handleSizeChange"
          @p-current-change="handleCurrentChange"
        >
        </lb-table>
      </div>
    </div>
  </div>
</template>

<script>
import bond from '../components/bondData.vue'
import LbTable from '../../../components/lb-table/lb-table'
export default {
  components: {
    bond,
    LbTable
  },
  data () {
    return {
      updatedTime: [],
      currentIndex: 0,
      name: '---',
      dialogUser: false,
      tableData: [
        {}, {}, {}
      ],
      btns: ['个人信息', '订单信息', '地址信息', '银行卡信息', '佣金记录', '收藏记录', '粉丝记录', '提现记录'],
      types: [
        {
          id: '1',
          name: '充值'
        },
        // {
        //   id: '2',
        //   name: '提现'
        // },
        {
          id: '3',
          name: '冻结'
        },
      ],
      searchForm: {
        pageNo: 1,
        pageSize: 10,
        platformId: '',
        updatedTimeStart: '',
        updatedTimeEnd: '',
        goodsName: '',
        type: '',
        status: '',
        platformId: ''
      },
      list: [
        {
          name: '天兰',
          image: 'https://fenxiao.muruji.com/internalSystem/3e45d792-e3d5-4823-99c9-7919ff1c7fd8'
        },
        {
          image: 'https://fenxiao.muruji.com/internalSystem/3e45d792-e3d5-4823-99c9-7919ff1c7fd8'
        },
        {
          image: 'https://fenxiao.muruji.com/internalSystem/3e45d792-e3d5-4823-99c9-7919ff1c7fd8'
        }
      ],
      columns: [
        { type: 'selection', minWidth: '80', fixed: 'left' },
        { label: '时间', prop: 'updatedTime', minWidth: '120' },
        { label: '类型', prop: 'typeLabel', minWidth: '220' },
        { label: '方式', prop: 'payType', minWidth: '100' },
        {
          label: '商品/账号', prop: 'categoryName', minWidth: '120',
          render: (h, scope) => {
            return (
              <div>
                {scope.row.goodsName}{scope.row.accountName}
              </div >
            )
          }
        },
        { label: '数量', prop: 'goodsNum', minWidth: '120' },
        { label: '金额', prop: 'modifyAmount', minWidth: '120' },
        { label: '状态', prop: 'statusLabel', minWidth: '120' },
        { label: '备注', prop: 'remarks', minWidth: '100' }
      ],
      page: { list: [], pageNo: 1, pageSize: 10, totalNum: 0, currentPage: 1, status: '' },
      hadRechargeAmount: '',
      awaitEarnestMoney: '',
      activeEarnestMoney: '',
      dictionaries: {},
    }
  },
  created () {
    this.getPlatformStatistics()
    this.getDictionaries('platform_earnest_status')
    this.fetchData()
  },
  methods: {
    //导出
    deriveDeliver () {
      this.$api.exportUserRecordList(this.searchForm).then(res => {
        if (res.code == 0) {
          this.downloadlink(res.data)
          this.$message({
            type: 'success',
            message: '导出成功!'
          })
        }
      })
    },
    downloadlink (url) {
      const iframe = document.createElement('iframe')
      iframe.style.display = 'none'
      iframe.src = url
      document.body.appendChild(iframe)
    },
    fetchData (type) {
      this.searchForm.platformId = this.$route.query.id
      if (this.updatedTime) {
        this.searchForm.updatedTimeStart = this.updatedTime[0]
        this.searchForm.updatedTimeEnd = this.updatedTime[1]
      }

      if (type == 'reset') {
        this.searchForm = {}
        this.updatedTime = []
        this.searchForm.platformId = this.$route.query.id
        this.searchForm.pageNo = 1
        this.searchForm.pageSize = 10
      }
      this.$api.getUserRecordPageList(this.searchForm).then(res => {
        if (res.code == 0) {
          res.data.list.forEach(item => {
            if (!item.payType) {
              item.payType = '--'
            }
          })
          this.page.list = res.data.list
          this.page.totalNum = res.data.totalNum
          this.loading = false
          this.getPlatformStatistics()
        }
      })
    },
    getPlatformStatistics () {
      let params = {
        platformId: this.$route.query.id
      }
      this.$api.getPlatformStatistics(params).then(res => {
        if (res.code == 0) {
          this.hadRechargeAmount = res.data.hadRechargeAmount
          this.awaitEarnestMoney = res.data.awaitEarnestMoney
          this.activeEarnestMoney = res.data.activeEarnestMoney
        }
      })
    },
    // 获取字典数据
    getDictionaries (type) {
      const params = { groupId: type }
      this.$api.dictionaries(params).then((res) => {
        this.dictionaries['platform_earnest_status'] = res.data
      }).catch((err) => {
        console.log(err)
      })
    },
    onMultipleSelection (val) {
      this.selectionGoods = val
    },
    handleCurrentChange (currentChange) {
      this.page.pageNo = currentChange
      this.searchForm.pageNo = currentChange
      this.fetchData()
    },
    handleSizeChange (sizeChange) {
      this.page.pageSize = sizeChange
      this.searchForm.sizeChange = sizeChange
      this.fetchData()
    },
    clickbtn (index) {
      this.currentIndex = index
    },
    toFreeze () {
      this.$router.push({
        name: 'freezeMoney',
        query: {
          id: this.$route.query.id
        }
      })
    }
  }
}
</script>
<style scoped>
.div1 {
  margin-left: -16px;
  background: url(../../../assets/breadcrumb2.png);
  width: 120px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  color: #2d7edf;
}

.div2 {
  margin-left: -16px;
  background: url(../../../assets/breadcrumb1.png);
  width: 120px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  color: #fff;
}
.dialog-search {
  display: flex;
  width: 46%;
  justify-content: space-between;
  margin-top: 10px;
  margin-left: 10px;
}
.title {
  display: flex;
  justify-content: space-between;
}
#base-list {
  margin-top: 20px;
  padding-bottom: 20px;
}
:deep(
    #base-list
      .lb-table
      .el-table
      .el-table__body
      .el-table__row
      .el-table__cell:last-child
      .cell
      div
  ) {
  display: inline-block;
  /* a {
    margin: 0 5px;
  } */
}
</style>
